/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, GetYoutubeIntegrationBroadcastsBroadcastsPathParams, GetYoutubeIntegrationBroadcastsBroadcastsQueryParams } from "../models/GetYoutubeIntegrationBroadcastsBroadcasts";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { getYoutubeIntegrationBroadcastsBroadcasts } from "../axios/getYoutubeIntegrationBroadcastsBroadcasts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const getYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey = (station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams) => ["web-app-bff-api", { url: '/youtube-broadcasts/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type GetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey = ReturnType<typeof getYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey>

export function getYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryOptions(station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey(station, params)
        return queryOptions<GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<Error>, GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubeIntegrationBroadcastsBroadcasts(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Computes on-air intervals from stream gaps in the requested window and enriches them with live/ended YouTube video metadata for the station channel.
 * @summary List on-air broadcasts for a station
 * {@link /youtube-broadcasts/:station}
 */
export function useGetYoutubeIntegrationBroadcastsBroadcastsSuspense<TData = GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, TQueryKey extends QueryKey = GetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey>(station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams, options: 
{
  query?: Partial<UseSuspenseQueryOptions<GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey(station, params)
         

         const query = useSuspenseQuery({
          ...getYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}